import React from 'react';
import LocationTemplate from './LocationTemplate';

const RichSquarePage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Rich Square"
      stateName="North Carolina"
      countyName="Northampton"
      zipCodes={["27869"]}
      latitude={36.2740}
      longitude={-77.2858}
      population={958}
      historicalFact="Incorporated in 1885, named for the fertile 'rich' farmland surrounding the town square."
      nearbyTowns={[
        "Ahoskie, NC",
        "Murfreesboro, NC",
        "Aulander, NC",
        "Woodland, NC",
        "Jackson, NC",
        "Kelford, NC",
        "Powellsville, NC",
        "Seaboard, NC"
      ]}
    />
  );
};

export default RichSquarePage;